<template>
  <section id="searchBrand" ref="searchBrand">
    <GarageBrand :brand_name="brand" :brand_id="carBrandId" :color_kv="color"></GarageBrand>
    <div hidden>BENTLEY Pre-owned Cars</div>
  </section>
</template>

<script>
import GarageBrand from '../components/GarageBrand'

let vm = null
export default {
  metaInfo: {
    title: 'Bentley Pre-owned Cars', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'Bentley Pre-owned Cars'
    },
    {
      name: 'description',
      content: 'Bentley Pre-owned Cars – Buy premium condition pre-owned cars with warranty.'
    }]
  },
  name: "BENTLEY",
  data() {
    return {
      metaData: 'Bentley Pre-owned Cars',
      carBrandId: 30,
      brand: 'Bentley',
      color: '#394D45',
      favicon: '/favicon_Bentley.ico'
    };
  },
  created() {
  },
  async mounted() {
    this.setFavicon()
  },
  beforeDestroy() {
    this.resetFavicon()
  },
  methods: {
    setFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = this.favicon
      }
    },
    resetFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = '/favicon.ico'
      }
    }
  },
  components: {
    GarageBrand
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/Bentley.vue